module.exports = __webpack_public_path__ + "img/Rectangle 148@2x.1c957784.png";